import React, { type FunctionComponent } from 'react'
import { useDashIntl } from 'intl/intl.hooks'
import EmptyView from 'legacy/components/EmptyView'
import { GeneratedReportsListRouteToNew } from 'legacy/sections/generated-reports/components/list/components/GeneratedReportsListRouteToNew'

export const GeneratedReportsListEmptyView: FunctionComponent = () => {
  const intl = useDashIntl()

  return (
    <EmptyView
      data-testid="generated-reports-list-empty"
      iconName="graphFilled"
      title={intl.formatMessage({ id: 'generatedReports.empty.title' })}
      body={intl.formatMessage({ id: 'generatedReports.empty.body' })}
      action={
        <GeneratedReportsListRouteToNew labelId="generatedReports.newReport.generateReport" />
      }
    />
  )
}
